import { render, staticRenderFns } from "./AddTodo.vue?vue&type=template&id=c039715c&scoped=true&"
import script from "./AddTodo.vue?vue&type=script&lang=js&"
export * from "./AddTodo.vue?vue&type=script&lang=js&"
import style0 from "./AddTodo.vue?vue&type=style&index=0&id=c039715c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c039715c",
  null
  
)

export default component.exports